export default defineAppConfig({})
